import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutocomplete from '@/components/BaseAutocomplete.vue'
import {
  AriregisterBasic,
  AriregisterContact,
} from '@/models/ariregister.model'
import {
  useFetchAriregisterBasic,
  useFetchAriregisterDetails,
} from '@/queries/ariregister'
import { computed, PropType, reactive, ref, watch } from 'vue'
import { Option } from '@/models/shared.model'
import { getValidationErrorData } from '@/utils/errors'
import { Language } from '@/enums/languages'


export enum ContactType {
  TELEPHONE = 'TEL',
  MOBILE = 'MOB',
  EMAIL = 'EMAIL',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyFinder',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  language: {
    type: String,
  },
  regCountry: {
    type: String,
    required: true,
  },
  errors: {
    type: Array as PropType<string[] | undefined>,
    default: () => [],
  },
},
  emits: ['optionClick', 'onCountrySelect'],
  setup(__props, { emit: emits }) {

const props = __props



const errors = ref()
const companySearchString = ref('')
const fetchCompanyTimeoutId = ref()
const compareString = ref('')
const companySearchResults = reactive<AriregisterBasic[]>([])
const isLoading = ref(false)

const form = {
  company: {
    name: '',
    reg_code: '',
    reg_country: props.regCountry,
    vat_number: null,
    email: '',
    phone: '',
    language: props.language,
  },
  address: {
    full_address: '',
    city_region: '',
    street: '',
  },
}

const { mutateAsync: fetchAriregisterBasic } = useFetchAriregisterBasic()
const { mutateAsync: fetchAriregisterDetails } = useFetchAriregisterDetails()

const getAriregisterLihtandmed = () => {
  isLoading.value = true
  clearTimeout(fetchCompanyTimeoutId.value)
  fetchCompanyTimeoutId.value = setTimeout(() => {
    if (compareString.value === companySearchString.value) return
    if (companySearchString.value?.length < 2) return
    fetchAriregisterBasic(companySearchString)
      .then((data) => {
        compareString.value = companySearchString.value
        Object.assign(companySearchResults, data)
      })
      .catch((error) => {
        console.error(error)
        errors.value = getValidationErrorData(error)
      })
      .finally(() => {
        isLoading.value = false
      })
  }, 500)
}

const ariregisterCompanies = computed<Option[]>(() => {
  return (companySearchResults || []).map((company: AriregisterBasic) => {
    return {
      key: company.code,
      label: company.name,
    }
  })
})

const onCompanySelect = (value) => {
  if (value.key) {
    isLoading.value = true
    fetchAriregisterDetails(value.key)
      .then((data) => {
        console.log({ data })

        companySearchString.value = value.label
        Object.assign(form.company, {
          name: data.name || '',
          reg_code: data.code || '',
          vat_number: typeof data.vat === 'string' ? data.vat : '',
          email: findContact(data.contacts, [ContactType.EMAIL]),
          phone: findContact(data.contacts, [
            ContactType.TELEPHONE,
            ContactType.MOBILE,
          ]),
        })
        if (data.inads_address) {
          Object.assign(form.address, data.inads_address)
        } else if (data.google_address) {
          Object.assign(
            form.address,
            { state: data.google_address.county },
            { city: data.google_address.city },
            { street: data.google_address.street },
            { house: data.google_address.number },
            { postal_code: data.google_address.zip_code },
            { full_address: data.google_address.google_address },
          )
        } else if (data.addresses.length) {
          Object.assign(form.address, {
            full_address: data.addresses[0].full_address,
            city_region: data.addresses[0].municipality,
            street: data.addresses[0].street,
          })
        }
        emits('optionClick', form)
      })
      .catch((error) => {
        console.error(error)
        errors.value = getValidationErrorData(error)
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

const findContact = (contacts: AriregisterContact[], types: string[]) => {
  const contact = contacts.find((c) => {
    return types.includes(c.type)
  })
  return contact?.value || ''
}

watch(
  () => props.errors,
  () => {
    errors.value = props.errors
  },
  { immediate: true },
)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutocomplete, {
    modelValue: companySearchString.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((companySearchString).value = $event)),
      _cache[2] || (_cache[2] = (value) => (companySearchString.value = value))
    ],
    options: _unref(ariregisterCompanies),
    "no-options-label": _ctx.$t('noResults'),
    label: _ctx.$t('registration.searchCompany'),
    errors: errors.value,
    "is-loading": isLoading.value,
    name: "googleAddress",
    "icon-left": "magnifying-glass",
    class: "company-finder",
    "disable-filtering": true,
    onKeyup: getAriregisterLihtandmed,
    onOptionClick: _cache[1] || (_cache[1] = (value) => onCompanySelect(value))
  }, null, 8, ["modelValue", "options", "no-options-label", "label", "errors", "is-loading"]))
}
}

})